import React from 'react';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import PaletteOutlinedIcon from '@mui/icons-material/PaletteOutlined';
import { ReactComponent as LogIQmindIcon } from 'assets/img/LogIQmindIcon.svg';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import PublishOutlinedIcon from '@mui/icons-material/PublishOutlined';
import { SvgIcon } from '@mui/material';
import { PortalNames } from "common/Portals";

export const SidebarData = [
    {
        title: "Dashboard",
        icon: <DashboardOutlinedIcon />,
        link: `/${PortalNames.Partner.Path}/dashboard`,
    },
    {
        title: "Accounting",
        icon: <PaymentsOutlinedIcon />,
        link: `/${PortalNames.Partner.Path}/accounting`,
    },
    {
        title: "Uploads",
        icon: <PublishOutlinedIcon />,
        link: `/${PortalNames.Partner.Path}/uploads`
    },
    {
        title: "Files",
        icon: <DescriptionOutlinedIcon />,
        link: `/${PortalNames.Partner.Path}/files`,
        index: 5,
    },
    {
        title: "Appearance",
        icon: <PaletteOutlinedIcon />,
        link: `/${PortalNames.Partner.Path}/appearance`,
    },
    {
        title: "LogIQmind Manager",
        icon: <SvgIcon>
                <LogIQmindIcon />
            </SvgIcon>,
        link: `/${PortalNames.Partner.Path}/logiqmind-manager`
    },
]
